/**
 * Transcode Jobs API Client
 *
 * Frontend wrapper for format conversion workflow operations
 * Uses the platform workflow templates system
 */

import axios from '@/axios'

export default {
  /**
   * Get available workflow templates for the organization
   */
  async getAvailableWorkflows() {
    try {
      const response = await axios.get('/api/transcode/workflows')
      return response.data
    } catch (error) {
      console.error('Get available workflows error:', error)
      throw error
    }
  },

  /**
   * Submit a transcode job
   * @param {Object} params Job parameters
   * @param {number} params.workflowTemplateId - Required: which workflow to use
   * @param {number} params.inputStorageConfigId - Required: source storage config
   * @param {string} params.inputPath - Required: S3 key of source file
   * @param {number} params.encodingPresetId - Optional: override encoding preset
   * @param {number} params.outputStorageConfigId - Optional: output storage config
   * @param {string} params.outputFilename - Optional: custom output filename
   * @param {number} params.mediaId - Optional: link to media record
   * @param {number} params.episodeId - Optional: link to episode record
   * @param {number} params.expectedDurationMs - Optional: for QC duration check
   */
  async submitJob(params) {
    try {
      const response = await axios.post('/api/transcode/submit', params)
      return response.data
    } catch (error) {
      console.error('Submit transcode job error:', error)
      throw error
    }
  },

  /**
   * Get job status
   * @param {string} jobId - Job UUID
   */
  async getJobStatus(jobId) {
    try {
      const response = await axios.get(`/api/transcode/job/${jobId}`)
      return response.data
    } catch (error) {
      console.error('Get transcode job status error:', error)
      throw error
    }
  },

  /**
   * Submit batch transcode jobs
   * @param {Object} params Batch parameters
   * @param {number} params.workflowTemplateId - Required: which workflow to use
   * @param {number} params.inputStorageConfigId - Required: source storage config
   * @param {Array} params.files - Required: array of files to process
   * @param {number} params.outputStorageConfigId - Optional: output storage config
   * @param {number} params.encodingPresetId - Optional: override encoding preset
   * @param {string} params.outputFolder - Optional: custom output folder
   */
  async submitBatchTranscode(params) {
    try {
      const response = await axios.post('/api/transcode/submit-batch', params)
      return response.data
    } catch (error) {
      console.error('Submit batch transcode error:', error)
      throw error
    }
  }
}
